"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Card](https://docs.vanillaframework.io/patterns/card/).
 *
 * There are four card styles available to use in Vanilla: default, header, highlighted and overlay. Our card component will expand to fill the full width of its parent container.
 */

const Card = _ref => {
  let {
    children,
    className,
    highlighted,
    overlay,
    thumbnail,
    title,
    ...props
  } = _ref;
  const titleId = (0, _react.useId)();
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    "aria-labelledby": title ? titleId : undefined,
    className: (0, _classnames.default)(className, {
      "p-card": !highlighted && !overlay,
      "p-card--highlighted": highlighted,
      "p-card--overlay": overlay
    }),
    role: "group"
  }, props), thumbnail && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
    className: "p-card__thumbnail",
    src: thumbnail,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("hr", {
    className: "u-sv1"
  })), title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "p-card__title",
    id: titleId
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "p-card__content"
  }, children));
};
var _default = exports.default = Card;